module.exports = __webpack_public_path__ + "img/notice-lb.062da6b2.png";